export const IMAGEPAYLOAD = {
    name: "",
    email:"",
    features:[],
    lightningAddress:"",
    amount:0,
    description:""
  };